import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ShopProductCard } from "../shop/ShopProductCard";
import { Reveal } from "../Reveal";
import { SectionHeading } from "../SectionHeading";

// New Arrivals — the most recently added published bracelets.
export const NewArrivals = ({ products = [] }) => {
  const list = [...products].sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0)).slice(0, 4);
  if (list.length === 0) return null;

  return (
    <section id="new-arrivals" className="scroll-mt-24 bg-brand-cream py-20 sm:py-28 lg:py-32" data-testid="new-arrivals-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-6">
            <SectionHeading
              overline="Just Landed"
              title="New Arrival Bracelets"
              text="Fresh from the bench — the latest bracelets to join the HESHAURA collection."
            />
            <Link
              to="/shop?sort=newest"
              data-testid="new-arrivals-view-all"
              className="group inline-flex items-center gap-2 border-b border-brand-gold/60 pb-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-gold transition-colors hover:border-brand-gold hover:text-brand-gold-hover"
            >
              See all new bracelets
              <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
        <div className="mt-12 grid grid-cols-2 gap-x-4 gap-y-9 sm:mt-16 sm:gap-6 md:grid-cols-4 lg:gap-6" data-testid="new-arrivals-grid">
          {list.map((p, i) => (
            <Reveal key={p.id} delay={(i % 4) * 0.1}>
              <ShopProductCard product={p} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
